jQuery( document ).ready( function () {
	jQuery( ".esports-team-member-icon:first" ).addClass( 'active' );
	jQuery( ".esports-team-container:first" ).addClass( 'active' );
	jQuery( ".player-container:first" ).addClass( 'active' );
	jQuery( ".esports-team-logo:first" ).addClass( 'active' );

	// Selecting a new player
	jQuery( ".esports-team-member-icon" ).click( function ( e ) {
		e.preventDefault(); // Prevent other actions from bubbling
		jQuery( ".esports-team-member-icon" ).removeClass( "active" ); // Toggle the active player
		jQuery( this ).addClass( "active" );
		jQuery( ".player-container" ).removeClass( "active" );
		jQuery( "#player-" + jQuery( this ).attr( "data-player-id" ) ).addClass( "active" );
	});

	// Selecting a new team
	jQuery( ".esports-team-logo" ).click( function ( e ) {
		e.preventDefault(); // Prevent other actions from bubbling
		var teamID = jQuery( this ).attr( "id" );
		jQuery( ".esports-team-container" ).removeClass( "active" );
		jQuery( ".esports-team-logo" ).removeClass( "active" );
		jQuery( this ).addClass( 'active' );
		jQuery( ".esports-team-member-icon" ).removeClass( "active" );
		jQuery( ".player-container" ).removeClass( "active" );
		jQuery( "#esports-team-container-" + teamID ).addClass( "active" );
		jQuery( "#esports-team-container-" + teamID + " .player-container:first" ).addClass( "active" );
		jQuery( "#esports-team-container-" + teamID + " .esports-team-icon-container img:first" ).addClass( "active" );
	} );
} );

